import { allpeepNoPayloadEndpoint } from './helpers.js';
export const previewLink = (rawClient) => allpeepNoPayloadEndpoint(rawClient, '/fetch-url/:url');
